var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "revoke"
  }, [_vm.message.flow === 'in' ? _c('span', [_vm._v(_vm._s(_vm.message.nick || _vm.message.from))]) : _vm.message.from === _vm.message.revoker ? _c('span', [_vm._v(_vm._s(_vm.TUITranslateService.t("TUIChat.您")))]) : _c('span', [_vm._v(_vm._s(_vm.message.revoker))]), _c('span', [_vm._v(_vm._s(_vm.TUITranslateService.t("TUIChat.撤回了一条消息")))]), _vm.message.flow === 'out' && _vm.isEditMsg ? _c('span', {
    staticClass: "edit",
    on: {
      "click": _vm.messageEdit
    }
  }, [_vm._v(_vm._s(_vm.TUITranslateService.t("TUIChat.重新编辑")))]) : _vm._e()]);
}
var staticRenderFns = []

export { render, staticRenderFns }